import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'internalText',
    label: 'Internal Text',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'borrowerInternalText',
    label: 'Borrower Internal Text',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'taskType',
    label: 'Associate Task Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'status',
    label: 'Status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const addConditionForm = {
  name: FormNames.ADD_CONDITION,
  label: 'Add Condition',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
